import { connect } from 'react-redux'
import { isMobileOnly } from 'react-device-detect'

import NotificationsList from './NotificationsList'
import {
  getNotificationsList,
  getNotificationsPendingGetNotificationsLoadMore,
  getNotificationsLoadedGetNotifications,
  getNotificationsPendingGetNotifications,
} from 'store/entities/notifications/selectors'
import { notificationsScroll } from 'store/entities/notifications/actions'
import { getIdentityUserData } from 'store/entities/identity/selectors'

const mapStateToProps = state => ({
  notificationsList: getNotificationsList(state),
  loaded: getNotificationsLoadedGetNotifications(state),
  pending: getNotificationsPendingGetNotifications(state),
  pendingMore: getNotificationsPendingGetNotificationsLoadMore(state),
  identity: getIdentityUserData(state),
  isMobileOnly,
})

const mapDispatchToProps = {
  handleScroll: ({ currentTarget }) => notificationsScroll(currentTarget),
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsList)
